import Vue from 'vue'
// eslint-disable-next-line import/no-duplicates
import VueNestable from 'vue-nestable'
// eslint-disable-next-line import/no-duplicates
import VueNestableHandle from 'vue-nestable'

Vue.use(VueNestable)
Vue.use(VueNestableHandle)
